import { Line } from "vue-chartjs";
import merge from "lodash/merge";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";
import { APP_COLORS } from "@/config/app-colors";

export default {
  name: "LineChart",
  extends: Line,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lineChartDefaultOptions: {
        scales: {
          scaleStartValue: 0,
          yAxes: [
            {
              gridLines: {
                display: true,
                drawBorder: false
              },
              ticks: {
                display: true,
                fontSize: 16,
                fontFamily: "Montserrat",
                fontColor: "#c3c5cd",
                padding: 8,
                stepSize: 1,
                beginAtZero: true,
                maxTicksLimit: 8
              },
              display: true
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              },
              display: true,
              type: "time",
              distribution: "series",
              time: {
                minUnit: "day",
                displayFormats: {
                  day: "MMM DD",
                  week: "MMM DD",
                  month: "MMM YYYY",
                  year: "MMM YYYY"
                }
              },
              ticks: {
                display: true,
                fontFamily: "Montserrat",
                fontColor: "#4a4f66",
                padding: 10
              }
            }
          ]
        },
        tooltip: {
          enabled: true
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      },
      chartColor: APP_COLORS.PRIMARY
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              pointBorderWidth: 3,
              pointHoverRadius: 3,
              pointHoverBorderWidth: 3,
              pointRadius: 3,
              fill: false,
              clip: 3,
              borderColor: this.chartColor,
              pointBorderColor: this.chartColor,
              pointBackgroundColor: this.chartColor,
              pointHoverBackgroundColor: this.chartColor,
              pointHoverBorderColor: this.chartColor
            }
          ]
        },
        merge(this.lineChartDefaultOptions, this.options)
      );
    }
  }
};
